import { createRouter, createWebHashHistory } from "vue-router";
import { api } from "@/plugins/api";

import ChatView from "../views/chat/Chat.vue";
import AboutView from "@/views/landing/AboutView.vue";
import TicketsView from "@/views/landing/TicketsView.vue";
import CarsView from "@/views/landing/CarsView.vue";
import LoginView from "@/views/auth/LoginView.vue";
import RegisterView from "@/views/auth/RegisterView.vue";

const routes = [
    {
        path: "/auth/login",
        name: "Login",
        component: LoginView,
    },
    {
        path: "/auth/register",
        name: "Register",
        component: RegisterView,
    },
    {
        path: "/",
        name: "HomeChat",
        component: ChatView,
        meta: { requiresAuth: true },
    },
    {
        path: "/chat/:chatId",
        name: "Chat",
        component: ChatView,
        meta: { requiresAuth: true },
    },
    {
        path: "/about",
        name: "About",
        component: AboutView,
        meta: { requiresAuth: true },
    },
    {
        path: "/tickets",
        name: "Tickets",
        component: TicketsView,
        meta: { requiresAuth: true },
    },
    {
        path: "/go",
        name: "Go",
        component: CarsView,
        meta: { requiresAuth: true },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !api.isAuthenticated()) {
        next({ name: "Login" });
    } else {
        next();
    }
});

export default router;
